// Abu Dhabi - female personal trainer. No trainer list.
const content = {
    slug: 'female-personal-trainer',
    title: 'Female Personal Trainer in Abu Dhabi | Villas & Compounds',
    description: (c) =>
        `Female personal trainers in Abu Dhabi for women-only sessions at home, in villa gyms and compounds. From ${c.money(c.lowest + c.mods.female, 0)} a session.`,
    eyebrow: 'Abu Dhabi · Female trainer',
    h1: 'Female Personal Trainer in Abu Dhabi',
    lead: 'Women-only training at home is the norm for many Abu Dhabi families. A female trainer comes to your villa or compound, works around the household\'s routine and keeps sessions private.',
    image: 'blog/health+and+fitness/girls-personal-training.jpg',
    imageAlt: 'Women training together with a female coach',
    facts: ['Women-only', 'Villa and compound gyms', 'Sisters and friends together'],
    ctaLabel: 'Request a female trainer',
    matchSummary: 'a female personal trainer in Abu Dhabi',
    packagesTitle: 'Packages with a female trainer',
    packagesHighlight: (c) => `A female trainer preference adds ${c.money(c.mods.female, 0)} a session. Two women sharing a session pay the partner rate each.`,
    sections: [
        {
            title: 'Sessions shaped around your home',
            cards: [
                { title: 'In the villa', body: 'A spare room, the majlis or the garden in winter. The trainer brings equipment and takes it away.' },
                { title: 'In compound gyms', body: 'Many compounds have a gym with ladies\' hours - your trainer can meet you there.' },
                { title: 'With family', body: 'Sisters, daughters and friends often train together; partner rates make it affordable.' },
            ],
        },
        {
            title: 'What women in Abu Dhabi most often ask for',
            tone: 'muted',
            items: [
                'Toning and strength without bulk.',
                'Getting back in shape after pregnancy.',
                'Losing weight steadily with family meals in the picture.',
                'Easing back pain from long drives and desk work.',
                'Training safely during Ramadan and in the hot months.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can a female trainer come to my villa in Abu Dhabi?',
            answer: 'Yes. Request a female trainer and tell us your area; sessions take place at your home.',
        },
        {
            question: 'Can my daughter and I train together?',
            answer: 'Yes - choose partner training. Each of you pays about 70% of the solo session price.',
        },
        {
            question: 'How much more does a female trainer cost?',
            answer: (c) => `${c.money(c.mods.female, 0)} a session on top of the package price.`,
        },
    ],
    schema: { name: 'Female Personal Trainer in Abu Dhabi' },
}

export default content
